<!-- Associated Agreements  -->
<div class="w-100 std-mt lg-mb" id="agreement-section">
    <div class="header-info">
        <h3>
            <span>{{ sectionTitle }}</span>
            <label style="font-size:14px; font-weight:normal; margin-left:20px;">
                <input
                    type="checkbox"
                    [(ngModel)]="showInactiveAgreements"
                    style="vertical-align:middle; margin-right:5px;"
                />
                Show inactive agreements
            </label>

        </h3>
        <button class="edit-button" (click)="showAddNewAgreement()">
            New Agreement
        </button>
    </div>

    <div *ngIf="agreements.length > 0; else noAgreements">
        <ng-container *ngFor="let agreement of agreements">
            <app-agreement-widget
                *ngIf="showInactiveAgreements || agreement.active"
                [agreement]="agreement"
                (agreementDeleted)="removeAgreement($event)"
                [clientName]="client_name"
                [venueName]="venue_name"
                [displayClientName]="displayClientName"
                [displayVenueName]="displayVenueName">
            </app-agreement-widget>
        </ng-container>
    </div>
</div>

<!-- TEMPLATES -->
<ng-template #noAgreements>
    <div class="list-container" *ngIf="!loadingAgreements">
        <div class="list-item">
            <p>No associated agreements found.</p>
        </div>
    </div>
    <div class="loader flex justify-center items-center std-mt" *ngIf="loadingAgreements">
        <mat-spinner color="warn" [diameter]="20"></mat-spinner>
        <span class="std-ml">Loading agreements...</span>
    </div>
</ng-template>

<!--  Add New Agreement Modal Content -->
<ng-template #addNewAgreementContent>

    <div *ngIf="!client_id">
        <div class="input-group" *ngIf="!createNewClient">
            <label>Associate Existing Client or <span class="sim-link" (click)="toggleCreateNewClient()">(Create New)</span></label>
            <app-typeahead
                class="no-flex" [clearOnItemSelect]="false" [itemTypeID]="'client'"
                [initialSelectedItem]="clientTypeaheadOption"
                (itemSelected)="handleClientOrVenueSelect($event, 'client')"
                (clearSelected)="newAgreementData.client_id = null;"
                [placeholder]="'Search clients...'"></app-typeahead>
        </div>
        <div class="input-group" *ngIf="createNewClient">
            <label>Create New Client or <span class="sim-link" (click)="toggleCreateNewClient()">(Associate Existing)</span></label>
            <label>New Client Name <span class="required-indicator">*</span></label>
            <input class="textbox p-10" type="text" [(ngModel)]="newClientName" placeholder="New client Name">
            <label>New Client Business Name <span class="required-indicator">*</span></label>
            <input class="textbox p-10" type="text" [(ngModel)]="newClientCompanyName" placeholder="New client Business Name">
            <label>New Client Billing Frequency <span class="required-indicator">*</span></label>
            <select class="textbox p-10" [(ngModel)]="newClientBillingFrequency">
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="net30">Net 30</option>
            </select>
        </div>
    </div>

    <div *ngIf="!venue_id">

        <div class="input-group" *ngIf="!createNewVenue">
            <label>Associate Existing Venue or <span class="sim-link" (click)="toggleCreateNewVenue()">(Create New)</span></label>
            <app-typeahead
                class="no-flex" [clearOnItemSelect]="false" [itemTypeID]="'venue'"
                [initialSelectedItem]="venueTypeaheadOption"
                (itemSelected)="handleClientOrVenueSelect($event, 'venue')"
                (clearSelected)="newAgreementDetails.kt_venue_id = null;"
                [placeholder]="'Search venues...'"></app-typeahead>
        </div>
        <div class="input-group" *ngIf="createNewVenue">
            <label>Create New Venue or <span class="sim-link" (click)="toggleCreateNewVenue()">(Associate Existing)</span></label>
            <label>Venue Name <span class="required-indicator">*</span></label>
            <input class="textbox p-10" type="text" [(ngModel)]="newVenueName" placeholder="New venue Name">
            <label>Venue Address</label>
            <input class="textbox p-10" type="text" [(ngModel)]="newVenueAddress" placeholder="New venue Address">
            <label>Venue City <span class="required-indicator">*</span></label>
            <input class="textbox p-10" type="text" [(ngModel)]="newVenueCity" placeholder="New venue City">
            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label>Venue State <span class="required-indicator">*</span></label>
                    <input class="textbox p-10" type="text" [(ngModel)]="newVenueState" placeholder="New venue State">
                </div>
                <div class="input-group">
                    <label>Venue Zip</label>
                    <input class="textbox p-10" type="text" [(ngModel)]="newVenueZip" placeholder="New venue Zip">
                </div>
            </div>
            <label>Is this a private venue?</label>
            <input type="checkbox" [(ngModel)]="newVenueIsPrivate" class="checkbox-input">
            <label>Is this a test venue?</label>
            <input type="checkbox" [(ngModel)]="newVenueIsTest" class="checkbox-input">
        </div>
    </div>

    <div class="input-group">
        <label>What kind of event is this? <span class="required-indicator">*</span></label>
        <div class="radio-group">
            <label class="radio-option">
                <input type="radio" name="gameType" value="trivia" [(ngModel)]="newAgreementDetails.game_type">
                <span>King Trivia</span>
            </label>
            <label class="radio-option">
                <input type="radio" name="gameType" value="slam" [(ngModel)]="newAgreementDetails.game_type">
                <span>Survey Slam</span>
            </label>
            <label class="radio-option">
                <input type="radio" name="gameType" value="bingo" [(ngModel)]="newAgreementDetails.game_type">
                <span>Music Bingo</span>
            </label>
        </div>
    </div>

    <div class="input-group">
        <label>
            <input type="checkbox" [(ngModel)]="newAgreementDetails.is_online" class="checkbox-input">
            Online Event
        </label>
    </div>

    <div class="input-group">
        <label>
            <input type="checkbox" [(ngModel)]="newAgreementDetails.is_ihh" class="checkbox-input">
            In-House Hosted
        </label>
    </div>

    <!-- <div class="input-group">
        <label>
            <input type="checkbox" [(ngModel)]="newAgreementData.is_private" class="checkbox-input">
            Private Event
        </label>
    </div> -->

    <div class="input-group">
        <label for="eventInterval">Event Interval <span class="required-indicator">*</span></label>
        <select [(ngModel)]="newAgreementDetails.event_interval" (change)="onEventIntervalChange()" id="eventInterval" class="textbox p-10">
            <option value="one-time">One-Time</option>
            <option value="weekly">Weekly</option>
            <!-- <option value="bi-weekly">Bi-weekly</option>
            <option value="monthly-first">Monthly - First Week</option>
            <option value="monthly-second">Monthly - Second Week</option>
            <option value="monthly-third">Monthly - Third Week</option>
            <option value="monthly-fourth">Monthly - Fourth Week</option>
            <option value="monthly-last">Monthly - Last Week</option> -->
        </select>
    </div>

    <div class="input-group" *ngIf="newAgreementDetails.event_interval === 'one-time'">
        <label for="eventName">Event Name</label>
        <input type="text" [(ngModel)]="newAgreementDetails.event_name" id="eventName" class="textbox p-10"
            placeholder="Enter special event name">
    </div>

    <div class="input-group">
        <div class="scheduler-container">
            <div class="scheduler-row" *ngIf="newAgreementDetails.event_interval !== 'one-time'">
                <span class="scheduler-label">Every</span>
                <select [(ngModel)]="newAgreementDetails.day_of_week" class="scheduler-select std-ml std-mr">
                    <option value="1">Sunday</option>
                    <option value="2">Monday</option>
                    <option value="3">Tuesday</option>
                    <option value="4">Wednesday</option>
                    <option value="5">Thursday</option>
                    <option value="6">Friday</option>
                    <option value="7">Saturday</option>
                </select>
                <span class="scheduler-label">at</span>
                <input type="time" [(ngModel)]="newAgreementDetails.event_time" class="scheduler-select std-ml">
            </div>

            <div class="scheduler-row" *ngIf="newAgreementDetails.event_interval === 'one-time'">
                <span class="scheduler-label">Date</span>
                <input type="date" [(ngModel)]="newAgreementDetails.event_date" class="textbox p-10 std-ml std-mr">
                <span class="scheduler-label">Time</span>
                <input type="time" [(ngModel)]="newAgreementDetails.event_time" class="textbox p-10  std-ml std-mr">
            </div>
        </div>
    </div>

    <!-- <div class="input-group">
        <label for="rate">Rate <span class="required-indicator">*</span></label>
        <input type="number" placeholder="$" [(ngModel)]="newAgreementDetails.rate" id="rate" class="textbox p-10"
            min="0" step="0.01" />
    </div> -->

    <div class="input-group">
        <label for="contractDate">Contract Date <span class="required-indicator">*</span></label>
        <input type="date" (change)="onContractDateChange()" [(ngModel)]="newAgreementData.contract_date"
            id="contractDate" class="textbox p-10">
    </div>

    <div class="input-group" *ngIf="newAgreementDetails.event_interval !== 'one-time'">
        <label for="firstEvent">First Event Date <span class="required-indicator">*</span></label>
        <input type="date" [min]="minFirstEventDate" (change)="onFirstEventDateChange()"
            [(ngModel)]="newAgreementData.first_event" id="firstEvent" class="textbox p-10">
    </div>

    <div class="input-group" *ngIf="newAgreementDetails.event_interval !== 'one-time'">
        <label>
            <input type="checkbox" [(ngModel)]="showLastEventDate" (change)="newAgreementData.last_event = null;" class="checkbox-input">
            Add a final event date
        </label>
    </div>

    <div class="input-group" *ngIf="newAgreementDetails.event_interval !== 'one-time' && showLastEventDate">
        <label for="lastEvent">Last Event Date</label>
        <input type="date" [(ngModel)]="newAgreementData.last_event" [min]="minLastEventDate" id="lastEvent" class="textbox p-10"
            placeholder="Leave blank for ongoing events">
    </div>

    <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>

<!-- MODALS -->
<!-- add new agreement modal -->
<app-basic-modal *ngIf="addNewAgreementIsActive" [template]="addNewAgreementContent" [hideX]="true"
    [staticBackground]="false" [title]="'Add New Agreement'" [cancel]="'Cancel'"
    (doCancel)="addNewAgreementIsActive = false; modalErrorMessage = ''"
    [action]="isSavingModal ? 'Creating...' : 'Create Agreement'" (doAction)="createNewAgreement()"
    [disabled]="isSavingModal">
</app-basic-modal>
